import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const PartnerlikPage = lazy(() => import('../pages/partnerlik/page'));
const GizlilikPage = lazy(() => import('../pages/gizlilik/page'));
const KullanimSartlariPage = lazy(() => import('../pages/kullanim-sartlari/page'));
const CerezPolitikasiPage = lazy(() => import('../pages/cerez-politikasi/page'));
const SSSPage = lazy(() => import('../pages/sss/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/partnerlik',
    element: <PartnerlikPage />,
  },
  {
    path: '/gizlilik',
    element: <GizlilikPage />,
  },
  {
    path: '/kullanim-sartlari',
    element: <KullanimSartlariPage />,
  },
  {
    path: '/cerez-politikasi',
    element: <CerezPolitikasiPage />,
  },
  {
    path: '/sss',
    element: <SSSPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
